module.exports = __webpack_public_path__ + "static/img/1ao.55600aaf.webp";